export default {
  'transactionReportingForm.title': 'Report Criteria',
  'transactionReportingForm.saveLabel': 'Save this report criteria',
  'transactionReportingForm.saveAsPlaceholder': 'Report name'
};
